import { render, staticRenderFns } from "./PlanOnboardSection.vue?vue&type=template&id=5ebf9450&scoped=true"
import script from "./PlanOnboardSection.vue?vue&type=script&lang=js"
export * from "./PlanOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./PlanOnboardSection.vue?vue&type=style&index=0&id=5ebf9450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf9450",
  null
  
)

export default component.exports